export var onToggleTab = function (callback) {
    var visible = true;
    window.addEventListener('focus', function () {
        if (!visible) {
            visible = true;
            callback(visible);
        }
    });
    window.addEventListener('blur', function () {
        visible = false;
        callback(visible);
    });
};
